import React from "react"
import { Container, Heading } from "@chakra-ui/react"

export default function Title() {
  return (
    <Container as="section" pb={0}>
      <Heading size="4xl" textAlign="center" mb={2} fontWeight="semibold">
        Our full list of services
      </Heading>
    </Container>
  )
}
